import environment from '@utilities/environment';
import { getPrefixedUrl } from '@utilities/get-prefixed-url';

import { ImageMode } from './image';

interface Setting {
    width?: number;
    height?: number;
    quality?: number;
}

const addUrlParameter = (url: string, key: string, value: string | number) => {
    const separator = url.indexOf('?') > -1 ? '&' : '?';

    return `${url}${separator}${key}=${value}`;
};

const createImageUrl = ({
    image,
    setting,
    mode = 'crop',
}: {
    image: string;
    setting: Setting;
    mode?: ImageMode;
}) => {
    let url = image;

    if (mode) url = addUrlParameter(image, 'mode', mode);
    if (setting.width) url = addUrlParameter(url, 'width', setting.width);
    if (setting.height) url = addUrlParameter(url, 'height', setting.height);

    // To prevent images with 100 quality to be rendered
    if (!url.includes('quality=')) url = addUrlParameter(url, 'quality', 80);

    if (environment.isLocal && url.startsWith('/media')) {
        url = getPrefixedUrl(url);
    }

    return url;
};

export default createImageUrl;
